import { BlogPost, listBlogPosts } from "@/content/blog";
import { LOCATIONS, LocationPage } from "@/content/locations";
import { RELATED_POSTS } from "@/content/blogLinks";

export function relatedBlogPosts(subject: any, limit = 10): BlogPost[] {
  const slug = typeof subject === "string" ? subject : subject?.slug;
  const allPosts = listBlogPosts();
  
  // 1. Prioritize manual mappings from blogLinks.ts
  const mappedSlugs = RELATED_POSTS[slug] ?? [];
  const mappedPosts = mappedSlugs
    .map(s => allPosts.find(p => p.slug === s))
    .filter(Boolean) as BlogPost[];

  if (mappedPosts.length >= limit) return mappedPosts.slice(0, limit);

  // 2. Prioritize by Category/Topic relevance
  const subjectCategory = typeof subject === "object" ? subject?.category : null;
  const relevantPosts = allPosts
    .filter(p => p.slug !== slug && !mappedSlugs.includes(p.slug))
    .filter(p => p.category === subjectCategory)
    .sort((a, b) => new Date(b.publishedISO).getTime() - new Date(a.publishedISO).getTime());

  const results = [...mappedPosts, ...relevantPosts];

  if (results.length >= limit) return results.slice(0, limit);

  // 3. Fallback to most recent posts
  const remainingLimit = limit - results.length;
  const recentPosts = allPosts
    .filter(p => p.slug !== slug && !results.some(r => r.slug === p.slug))
    .sort((a, b) => new Date(b.publishedISO).getTime() - new Date(a.publishedISO).getTime())
    .slice(0, remainingLimit);

  return [...results, ...recentPosts];
}

export function relatedLocations(service: any, limit = 4): LocationPage[] {
  // Map services to relevant test markets
  return LOCATIONS.slice(0, limit);
}


